import * as Sentry from '@sentry/react'
import { excludeGraphQLFetch } from 'apollo-link-sentry'
import { isProd } from 'consts'
import type { DecodedJWT } from 'hooks/use-auth-token'

const { VITE_SENTRY_DSN_HOST, VITE_RELEASE_VERSION } = import.meta.env

export const initSentry = () => {
  Sentry.init({
    dsn: VITE_SENTRY_DSN_HOST,
    release: VITE_RELEASE_VERSION,
    environment: isProd ? 'production' : 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: isProd ? 1.0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeBreadcrumb: excludeGraphQLFetch
  })
}

export const setSentryUser = (token: DecodedJWT | null) => {
  if (token) {
    Sentry.setUser({
      id: token.merchantId,
      email: token.email,
      merchantId: token.merchantId,
      companyId: token.companyId,
      accessType: token.accessType,
      tokenId: token.tokenId
    })
  } else {
    Sentry.setUser(null)
  }
}
